/* Read GET parameter */
export function getParameter(parameterName) {
  let result = false, tmp = []
  let items = location.search.substr(1).split("&")
  for (let index = 0; index < items.length; index++) {
    tmp = items[index].split("=")
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
  }
  return result
}

/* Decode HTML entities */
export let decodeEntities = (function() {
  let element = document.createElement('div');

  function decodeHTMLEntities (str) {
    if(str && typeof str === 'string') {
      str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
      str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
      element.innerHTML = str;
      str = element.textContent;
      element.textContent = '';
    }
    return str;
  }
  return decodeHTMLEntities;
})();

export function updateHash(hash) {
  const id = hash.replace(/^.*#/, '')
  const elem = document.getElementById(id)
  if (elem != null) {
    elem.id = `${id}-tmp`
  }
  window.location.hash = hash
  if (elem != null) {
    elem.id = id
  }
}

export function slugifyString(originalString, glue) {
  if (glue == undefined) {
    glue = '-';
  }
  return originalString.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/[^a-z0-9_\- ]/g, '').replace(/\s+/g, glue)
}

export function getSlugFromURL(url) {
  var cleanedUrl = url.endsWith('/') ? url.slice(0, -1) : url
  var segments = cleanedUrl.split('/')
  var lastSegment = segments.pop() || segments.pop()
  return lastSegment
}
